import { render } from "./AvatarMulti.vue?vue&type=template&id=a6af225a"
import script from "./AvatarMulti.vue?vue&type=script&lang=js"
export * from "./AvatarMulti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__